import axios from 'axios'

class ContentRepository {
  get (data) {
    console.log(data)
    return axios.get(`${BASE_URL}/content/${data}`)
    .then(response => {
      console.log(response.data)
      return response.data
    })
  }
}

export default new ContentRepository()



// WEBPACK FOOTER //
// ./src/data/content.repository.js